// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__4tU0U","spinner":"LoadingSpinner_spinner__+PytG"};